import { FunctionComponent } from 'react';
import dayjs from 'dayjs';
import celendar from 'dayjs/plugin/calendar';
dayjs.extend(celendar);
import _ from 'lodash';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetNews } from '~components/hooks';

export const ReadMore: FunctionComponent = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const getNews = useGetNews(
    {
      where: {
        id: {
          not: { in: id },
        },
      },
      orderBy: [{ publishDate: 'desc' }],
      take: 3,
    },
    'ReadMore',
  );

  return (
    <section className="news-read-more">
      <div className="news-read-more-title">{t('news-read-more-title')}</div>
      <div className="news-read-more-wrap">
        {_.map(getNews?.data?.posts, getNews => (
          <Link
            className="news"
            key={getNews.id}
            to={`/blog/post/${getNews?.id}`}
          >
            {getNews.tags[0]?.name && (
              <span className="news-badge">
                {t(`blog tag ${getNews.tags[0]?.name}`)}
              </span>
            )}
            <img
              src={`https://keystone.trustunboxing.com${getNews?.background?.url}`}
              alt={getNews?.title}
            />
            <span className="news-content">
              <span className="news-name">{getNews?.title}</span>
              <span className="news-author">
                <img
                  className="news-author-logo"
                  src={`https://keystone.trustunboxing.com${getNews?.author?.avatar?.url}`}
                  alt={getNews?.author?.name}
                />
                <span className="news-author-content">
                  <span className="news-author-name">
                    {getNews?.author?.name}
                  </span>
                  <span className="news-author-date">
                    {dayjs(getNews?.publishDate).calendar()}
                  </span>
                </span>
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};
